// Behavioral wrapper around a <video> + its .video-toggle-btn play/pause button.
// Replaces the former inline onclick handlers. Pure DOM, no imports.
class VideoToggle extends HTMLElement {
  #controller = new AbortController();

  get #video() {
    const video = this.querySelector('video');
    if (!(video instanceof HTMLVideoElement)) throw new Error('video-toggle: <video> missing');
    return video;
  }

  get #button() {
    const button = this.querySelector('.video-toggle-btn');
    if (!(button instanceof HTMLElement)) throw new Error('video-toggle: .video-toggle-btn missing');
    return button;
  }

  connectedCallback() {
    const { signal } = this.#controller;
    this.#button.addEventListener('click', this.#onClick, { signal });
    this.#video.addEventListener('play', this.#sync, { signal });
    this.#video.addEventListener('pause', this.#sync, { signal });
    this.#sync();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #onClick = (event) => {
    event.preventDefault();
    event.stopPropagation(); // also covers the product-highlights <a> wrapper
    const video = this.#video;
    if (video.paused) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  };

  #sync = () => {
    const paused = this.#video.paused;
    this.#button.classList.toggle('is-paused', paused);
    const label = paused ? this.dataset.labelPlay : this.dataset.labelPause;
    if (label) this.#button.setAttribute('aria-label', label);
  };
}

if (!customElements.get('video-toggle')) {
  customElements.define('video-toggle', VideoToggle);
}
